var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.15463 0.197199C9.02945 0.0709905 8.85906 0 8.6813 0C8.50354 0 8.33314 0.0709905 8.20796 0.197199L3.2413 5.17053L1.15463 3.0772C0.979571 2.90809 0.727592 2.84523 0.493612 2.91228C0.259632 2.97933 0.0791982 3.16612 0.0202784 3.40228C-0.0386414 3.63844 0.032904 3.88809 0.207964 4.0572L2.76796 6.6172C2.89314 6.74341 3.06354 6.8144 3.2413 6.8144C3.41906 6.8144 3.58945 6.74341 3.71463 6.6172L9.15463 1.1772C9.29144 1.05099 9.36925 0.873331 9.36925 0.687199C9.36925 0.501066 9.29144 0.323409 9.15463 0.197199Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.ae16a6113d2c79f3ebd243d08c81ec03.svg";
export { ForwardRef as ReactComponent };